import { render, staticRenderFns } from "./part-b.vue?vue&type=template&id=c19fd722&"
import script from "./part-b.vue?vue&type=script&lang=js&"
export * from "./part-b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports